import { Box } from '@atlaskit/primitives';
import React from 'react';

export const LayoutBoysenberry = ({
	children,
	isFullscreen,
}: {
	children: React.ReactNode;
	isFullscreen?: boolean;
}) => {
	if (isFullscreen) {
		return children;
	}

	return <Box padding="space.400">{children}</Box>;
};
